import React from "react";
import TrainerList from "../../components/event/TrainerList";

const TrainersPage = () => {
    return <TrainerList/>
}

export default TrainersPage;
